import { Box, Text, Button, useBreakpointValue, Flex } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Layout from "../components/layouts/main";

const MotionBox = motion(Box);
const MotionText = motion(Text);

const NotFound = () => {
	const isMobile = useBreakpointValue({ base: true, md: false });

	return (
		<Layout>
			<MotionBox
				display="flex"
				alignItems="center"
				justifyContent="center"
				height="80vh"
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ duration: 0.5 }}
				overflow="hidden"
				m={0} // Устанавливаем margin 0
			>
				<Flex
					flexDirection="column"
					alignItems="center"
					textAlign="center"
					p={4}
				>
					<MotionText
						fontSize="6xl"
						fontWeight="bold"
						color="black"
						initial={{ y: -20 }}
						animate={{ y: 0 }}
						transition={{ duration: 0.5 }}
					>
						404
					</MotionText>
					<MotionText
						fontSize="2xl"
						color="black"
						initial={{ y: 20 }}
						animate={{ y: 0 }}
						transition={{ duration: 0.5 }}
						mb={4}
					>
						Sorry, the page you are looking for is not found
					</MotionText>
					<Button
						as={Link}
						to="/"
						background="#FF684B"
						color="white"
						_hover={{ background: "#FF5733" }}
						// height={!isMobile ? "58px" : "35px"}
						size={!isMobile ? 'md' : 'sm'}
					>
						Go to Home
					</Button>
				</Flex>
			</MotionBox>
		</Layout>
	);
};

export default NotFound;
